import { clamp, easeOutCubic, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createPhoenix(): DrawFn {
  const rng = mulberry32(112)
  const parts = Array.from({ length: 180 }, () => ({
    side: rng() > 0.5 ? 1 : -1,
    u: rng(),
    v: rng(),
    s: 0.8 + rng() * 2.6,
    hot: rng(),
    delay: rng() * 0.9,
    rise: 20 + rng() * 70,
    spin: (rng() - 0.5) * 2,
  }))

  return (ctx, t, w, h) => {
    const cx = w * 0.5
    const cy = h * 0.46
    ctx.clearRect(0, 0, w, h)
    const intro = easeOutCubic(clamp(t / 1.5))
    const unfurl = easeOutCubic(clamp((t - 0.15) / 1.6))

    ctx.globalCompositeOperation = 'lighter'
    glow(ctx, cx, cy + 20, 130 * intro, 'rgba(255,60,10,0.22)')
    glow(ctx, cx, cy + 40, 40 * intro, 'rgba(255,200,80,0.55)')

    for (const p of parts) {
      const age = Math.max(0, t - p.delay)
      const wing = Math.sin(p.u * Math.PI) ** 0.7
      const spread = (40 + p.u * 130) * unfurl
      const lift = (p.v - 0.55) * 170 * unfurl
      const flap = Math.sin(t * 1.6 + p.u * 3) * 10 * unfurl
      const x = cx + p.side * (spread * wing + flap)
      const y = cy + lift - age * p.rise * 0.15 - Math.sin(p.u * 2) * 8
      const fade = 0.25 + 0.75 * Math.sin(p.v * Math.PI)
      const a = fade * intro * (p.hot > 0.75 ? 0.9 : 0.55)
      ctx.fillStyle =
        p.hot > 0.65
          ? `rgba(255,220,140,${a})`
          : `rgba(255,${70 + p.hot * 90 | 0},30,${a})`
      ctx.save()
      ctx.translate(x, y)
      ctx.rotate(p.side * 0.4 + t * p.spin * 0.15)
      ctx.beginPath()
      ctx.ellipse(0, 0, p.s * 1.8, p.s * 0.7, 0, 0, TAU)
      ctx.fill()
      ctx.restore()
    }

    // rising ash
    for (let i = 0; i < 24; i++) {
      const u = (t * 0.12 + i * 0.04) % 1
      const x = cx + Math.sin(i * 1.7 + t) * 70
      const y = cy + 80 - u * 260
      ctx.fillStyle = `rgba(255,120,40,${(1 - u) * 0.35})`
      ctx.beginPath()
      ctx.arc(x, y, 1.2, 0, TAU)
      ctx.fill()
    }

    ctx.globalCompositeOperation = 'source-over'
  }
}
